import {
    cancelProductConfiguration,
    CancelProductConfigurationApiV1Parameter,
} from "@husky-hrc/Framework/Services/ProductConfigServiceV1";
import { ResponseDto } from "@husky-hrc/Framework/Types/ApiModel";
import Constants from "@husky-hrc/Utilities/Constants";
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    Handler,
    HasOnException,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

type Parameter = CancelProductConfigurationApiV1Parameter & HasOnSuccess<ResponseDto> & HasOnException<string>;
type Props = {
    apiParameter: CancelProductConfigurationApiV1Parameter;
    apiResult: ResponseDto;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await cancelProductConfiguration(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onException?.(error.errorJson.message);
            return false;
        }

        throw error;
    }
};

export const DispatchRemoveProductConfig: HandlerType = props => {
    props.dispatch({
        type: Constants.Actions.RemoveProductConfig,
        productId: props.parameter.productId,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchRemoveProductConfig, ExecuteOnSuccessCallback];

const cancelProductConfig = createHandlerChainRunner(chain, "CancelProductConfig");
export default cancelProductConfig;
